export default "__VITE_ASSET__b530f447__"